import axios from "axios";
import moment from "moment";
import React, { useEffect, useState, KeyboardEvent, ChangeEvent } from "react";
import { Button, Form, Spinner, Table } from "react-bootstrap";
import Checkbox from "src/components/common/checkbox";
import {Checkbox as FluentCheckbox} from "@fluentui/react";
import AxiosConfig from "src/utilities/AxiosConfig";
import BillingTableEditableCell from "../../../components/css/BillingGroupPricing/BillingTableEditableCell";
import Modal from 'react-bootstrap/Modal';
import { connect } from "react-redux";
import { qsStringify } from "src/utilities/helper";
import BillingGroupNewPricing from "../../../components/css/BillingGroupPricing/BillingGroupNewPricing";
import { Prompt } from "react-router";
import logger from '../../../utilities/logging';
import AddAvailableResponse from "src/components/css/BillingGroupPricing/AddAvailableResponse";
import AddLocatorResponse from "src/components/css/BillingGroupPricing/AddLocatorResponse";
import "./BillingGroupPricing.css"
import "../../../components/css/Quickbooks/ReportDisplay.css"
import EditAvailableResponse from "src/components/css/BillingGroupPricing/EditAvailableResponse";
import Select from 'react-select';
import dayjs from 'dayjs';

interface billingGroupsProps {
    BillingGroupID: number,
    BillingGroupName: string
}
interface billingTableDataProps {
    UtilityName: string
    BillingResponse: string
    BillingID: number
    LocatorResponse: string
    ResponseID: number
    Price?: number
    PS?: number
    UR?: string
    knt?: number
    Op?: string
    EffectiveDate: string
    ExpirationDate: string
    ContractExpirationDate: string
    BillingGroupPriceID: number
    IsAutoRenew: boolean
}
interface newBillingTableDataProps {
    UtilityName: string
    BillingResponse: string
    BillingID: number
    LocatorResponse: string
    ResponseID: number
    Price?: number
    PS?: number
    UR?: string
    knt?: number
    Op?: string
    EffectiveDate: string
    ExpirationDate: string
    BillingGroupPriceID: number
    newPrice: string
    ContractExpirationDate: string
    IsAutoRenew: boolean
}
interface billingResponsesProps {
    BillingID: number
    BillingResponse: string
    EntryDate?: string
}
interface utilityProps {
    UtilityID: number
    UtilityName: string
    ContractID: number
    ContractExpirationDate: string
}
interface locatorProps {
    ResponseID: number
    LocatorResponse: string
}
interface EventDictionary<TValue> {
    [id: string]: TValue
}

function BillingGroupPricing(props: any) {
    let typingTimeout: number | any = 0

    const [emptyLocate, setEmptyLocate] = useState<string[]>([])
    const [billingResponses, setBillingResponses] = useState<billingResponsesProps[]>([{ BillingResponse: "", BillingID: 0 }])
    const [viewDate, setViewDate] = useState<number | null>(Date.now())
    const [billingGroups, setBillingGroups] = useState<billingGroupsProps[]>()
    const [billingDropdownTop, setBillingDropdownTop] = useState<string>()
    const [includeInactiveBillingGroups, setIncludeInactiveBillingGroups] = useState(false)
    const [viewBillingGroupTable, setViewBillingGroupTable] = useState(false)
    const [billingGroupTableTitle, setBillingGroupTableTitle] = useState<string>()
    const [billingGroupTableID, setBillingGroupTableID] = useState<number>()
    const [billingTableData, setBillingTableData] = useState<billingTableDataProps[]>()
    const [billingUtilities, setBillingUtilities] = useState<utilityProps[]>()
    const [billingLocators, setBillingLocators] = useState<EventDictionary<locatorProps[]>>({})
    const [loading, setLoading] = useState(false)
    const [newRow, setNewRow] = useState<billingTableDataProps>({
        UtilityName: "",
        BillingResponse: "",
        BillingID: 0,
        LocatorResponse: "",
        ResponseID: 0,
        Price: undefined,
        PS: 1,
        UR: "U",
        knt: -1,
        Op: ">",
        EffectiveDate: new Date(Date.now()).toISOString(),
        ExpirationDate: new Date(Date.now()).toISOString(),
        BillingGroupPriceID: -99,
        ContractExpirationDate: "",
        IsAutoRenew: false
    })
    const [expire, setExpire] = useState("")
    const userId = props.userid
    const [insertRow, setInsertRow] = useState(false)
    const [generateModal, setGenerateModal] = useState(false)
    const [newEffectiveDate, setNewEffectiveDate] = useState(Date.now())
    const [percentageIncrease, setPercentageIncrease] = useState<number>()
    const [newBillingGroupTable, setNewBillingGroupTable] = useState(false)
    const [newPriceData, setNewPriceDate] = useState<newBillingTableDataProps[]>()
    const [addRowCon, setAddRowCon] = useState(false)
    const [cancelAddRow, setCancelAddRow] = useState(false)
    const [billingResponseModal, setBillingResponseModal] = useState(false)
    const [locatorResponseModal, setLocatorResponseModal] = useState(false)
    const [availableLocatorResponseModal, setAvailableLocatorResponseModal] = useState(false)
    const [newResponse, setNewResponse] = useState("")
    const [tab, setTab] = useState('Add')
    const [selectedBillingGroupOption, setSelectedBillingGroupOption] = useState<{ value: string, label: string } | null>(null);
    const [autoSearchLoading, setAutoSearchLoading] = useState<string | undefined>();
    //r-18-lint-cn
    //eslint-disable-next-line
    const [acDc, setACDC] = useState<EventDictionary<string>>({})
    const cancelClick = () => {
        setNewPriceDate([])
        setNewBillingGroupTable(false)
        setViewBillingGroupTable(true)

    }
    const billingGroupType = (bool: boolean) => {
        axios.get(process.env.REACT_APP_API_URL + `/api/billing/groups/${bool}`, AxiosConfig.configValue("min"))
            .then((res) => {
                var data = res.data.sort((a: billingGroupsProps, b: billingGroupsProps) => a.BillingGroupName > b.BillingGroupName ? 1 : -1)
                setBillingGroups(data)
            })
            .catch(error => {
                alert("There was an error getting Billing Groups");
                //console.log(error);
                logger.Error({
                    EventMessage: `BillingGroupPricing -> GetBillingGroups -> Error : ${JSON.stringify(error)}`,
                    EventCategory: "httprequest"
                });
                AxiosConfig.handleError(error);
            })
        axios.get(process.env.REACT_APP_API_URL + `/api/billing/responses/`, AxiosConfig.configValue("min"))
            .then((res) => {
                let data = res.data
                data = data.sort((a: billingResponsesProps, b: billingResponsesProps) => a.BillingResponse.toUpperCase() > b.BillingResponse.toUpperCase() ? 1 : -1)
                setBillingResponses(data)
            })
            .catch(error => {
                alert("There was an error getting Responses");
                logger.Error({
                    EventMessage: `BillingGroupPricing -> GetBillingResponses -> Error : ${JSON.stringify(error)}`,
                    EventCategory: "httprequest"
                });
                AxiosConfig.handleError(error);
            })
    }

    const viewBillingGroup = () => {
        var viewBillingGroup = true
        setLoading(true)
        if (isNaN(moment(viewDate).valueOf()) || viewDate == null) {
            alert("Invalid date entry")
            return null
        }
        let param = billingGroups?.find(x => x.BillingGroupName === billingDropdownTop)?.BillingGroupID
        if (param) {
            setBillingGroupTableTitle(billingDropdownTop)
            setBillingGroupTableID(param)
        }
        let billingUtills: utilityProps[]
        let responses: EventDictionary<locatorProps[]> = billingLocators
        axios.get(process.env.REACT_APP_API_URL + `/api/billing/utilities/${param}`, AxiosConfig.configValue("min"))
            .then((res) => {
                billingUtills = res.data ?? []
                let newRow: billingTableDataProps = {
                    UtilityName: res.data[0]?.UtilityName ?? "",
                    BillingResponse: billingResponses[0]?.BillingResponse ?? "",
                    BillingID: billingResponses[0]?.BillingID ?? 0,
                    LocatorResponse: "",
                    ResponseID: 0,
                    Price: undefined,
                    PS: 1,
                    UR: "U",
                    knt: -1,
                    Op: ">",
                    EffectiveDate: new Date(viewDate).toISOString(),
                    ExpirationDate: new Date(viewDate).toISOString(),
                    BillingGroupPriceID: -99,
                    ContractExpirationDate: expire,
                    IsAutoRenew: false
                }
                res.data.forEach((x: any) => {
                    axios.get(process.env.REACT_APP_API_URL + `/api/billing/locator/${x.UtilityID}`, AxiosConfig.configValue("min"))
                        .then((res) => {
                            if (x.UtilityName === newRow.UtilityName) {
                                newRow.LocatorResponse = res.data[0].LocatorResponse
                                newRow.ResponseID = res.data[0].ResponseID
                            }
                            responses[x.UtilityName] = res.data
                        }
                        )
                        .finally(() => {
                            setBillingLocators({ ...responses })
                            setNewRow({ ...newRow })
                            setLoading(false)
                        })
                        .catch(error => {
                            setAutoSearchLoading(undefined);
                            alert("There was an error getting Locator Responses");
                            //console.log(error);
                            logger.Error({
                                EventMessage: `BillingGroupPricing -> GetBillingGroupResponses -> Error : ${JSON.stringify(error)}`,
                                EventCategory: "httprequest"
                            });
                            AxiosConfig.handleError(error);
                            viewBillingGroup = false
                            setLoading(false)
                        })
                })
            })
            .finally(() => {
                axios.get(process.env.REACT_APP_API_URL + `/api/billing/table/${param}/${viewDate}`, AxiosConfig.configValue("min"))
                    .then(async (res) => {
                        let utilities = Array.from(new Set(res.data.map((x: utilityProps) => x.UtilityName))) ?? []
                        if((billingUtills == null && utilities == null) || (billingUtills.length < 1 && utilities.length < 1)){
                            alert("No Utilities found for Billing group, please add utility to billing group to continue.")
                            viewBillingGroup = false
                            setViewBillingGroupTable(false)
                            setLoading(false)
                            setAutoSearchLoading(undefined);
                            return;
                        }
                        let locator = responses
                        let emptyLocate: string[] = []
                        //r-18-lint-cn
                        //eslint-disable-next-line
                        await Promise.all(utilities.map((y) => {
                            if (!billingUtills?.find((x) => x.UtilityName === y)) {
                                axios.get(process.env.REACT_APP_API_URL + `/api/utility/GetSingleBillingUtility/${y}`, AxiosConfig.configValue("min"))
                                    .then((res) => {
                                        if(res.data.utility == null){
                                            alert(`Utility information missing for Billing group, please check if there is an active contract for utility ${y}.`)
                                            viewBillingGroup = false
                                            setViewBillingGroupTable(false)
                                            setLoading(false)
                                            return;
                                        }
                                        var data = res.data.locators ?? []
                                        if (data.length === 0) {
                                            emptyLocate.push(y as string)
                                            setEmptyLocate(emptyLocate)
                                        }
                                        locator[res.data.utility.UtilityName] = data
                                        billingUtills.push(res.data.utility)
                                        setBillingLocators({ ...locator })
                                    })
                            }
                        }))
                        setBillingUtilities(billingUtills)
                        setBillingTableData([...res.data])
                        setAutoSearchLoading(undefined);
                    })
                    .catch(error => {
                        setAutoSearchLoading(undefined);
                        alert("There was an error getting Billing Group Pricing Utilities");
                        //console.log(error);
                        logger.Error({
                            EventMessage: `BillingGroupPricing -> GetBillingGroupUtilities -> Error : ${JSON.stringify(error)}`,
                            EventCategory: "httprequest"
                        });
                        AxiosConfig.handleError(error);
                        viewBillingGroup = false
                        setLoading(false)
                    })
            })
            .finally(() => setViewBillingGroupTable(viewBillingGroup))
            .catch(error => {
                setAutoSearchLoading(undefined);
                alert("There was an error getting Billing Group Pricing Table");
                //console.log(error);
                logger.Error({
                    EventMessage: `BillingGroupPricing -> GetBillingGroupTable -> Error : ${JSON.stringify(error)}`,
                    EventCategory: "httprequest"
                });
                AxiosConfig.handleError(error);
                setViewBillingGroupTable(false)
                setLoading(false)
            })
    }

    const setNewRowData = (edit: string, index: string, id?: number) => {
        let edits = newRow
        if (index === "UtilityName") {
            edits.UtilityName = edit
        }
        if (index === "BillingResponse") {
            edits.BillingResponse = edit
            let ids = billingResponses.find(x => x.BillingResponse === edit)?.BillingID
            if (ids) edits.BillingID = ids
        }
        if (index === "LocaterResponse") {
            edits.LocatorResponse = edit
            let ids = billingLocators[newRow.UtilityName].find(x => x.LocatorResponse === edit)?.ResponseID
            if (ids) edits.ResponseID = ids
        }
        if (index === "Price") {
            let p = Number(edit) * 100
            p = Math.round(p) / 100
            edits.Price = p
        }
        if (index === "PS") {
            edits.PS = Number(edit)
        }
        if (index === "UR") {
            edits.UR = edit
        }
        if (index === "knt") {
            edits.knt = Number(edit)
        }
        if (index === "Op") {
            edits.Op = edit
        }
        if (index === "EffectiveDate") {
            edits.EffectiveDate = isNaN(moment(edit).valueOf()) ? "" : new Date(edit).toISOString()
        }
        if (index === "ExpirationDate") {
            edits.ExpirationDate = isNaN(moment(edit).valueOf()) ? "" : new Date(edit).toISOString()
        }
        if(index === "IsAutoRenew"){
            edits.IsAutoRenew = !edits.IsAutoRenew
        }
        setNewRow({ ...edits })
    }
    const insertPricingRow = async (row: billingTableDataProps, utility: utilityProps) => {
        let expired = new Date(row.ExpirationDate)
        expired.setHours(0, 0, 0, 0)
        let effect = new Date(row.EffectiveDate)
        effect.setHours(0, 0, 0, 0)
        axios.post(process.env.REACT_APP_API_URL + "/api/billing/AddBillingGroupPricing/", qsStringify({
            BillingGroupID: billingGroupTableID,
            UtilityCount: row.knt,
            Operator: row.Op,
            UtilityID: utility.UtilityID,
            ResponseID: row.ResponseID,
            BillingID: row.BillingID,
            Price: row.Price,
            SubPriceSchedule: row.UR,
            PriceScheduleID: row.PS,
            EffectiveDate: effect.toUTCString(),
            ExpirationDate: expired.toUTCString(),
            IsAutoRenew: row.IsAutoRenew,
            ContractExpirationDate: expire,
            ContractID: utility.ContractID,
            CreatedDate: new Date().toUTCString(),
            CreatedBy: userId,
        }), AxiosConfig.configValue())
            .then((res) => {
                if(res.data.error.success === false){
                    throw new Error(res.data.error.message)
                }
            })
            .finally(() => viewBillingGroup())
            .catch(error => {
                alert("There was an error inserting Billing Group Pricing" + error);
                //console.log(error);
                logger.Error({
                    EventMessage: `BillingGroupPricing -> AddBillingGroupPricing -> Error : ${JSON.stringify(error)}`,
                    EventCategory: "httprequest"
                });
                AxiosConfig.handleError(error);
            })
    }

    const insertNewPricingRow = (row: billingTableDataProps) => {
        if (Object.values(row).every((x) => x !== null && x !== undefined && x !== "")) {
            setInsertRow(false)
            let utility = utilityIdsSearch(row.UtilityName)
            let billingGroupID = billingGroupTableID ?? -99
            if (viewDate == null) {
                alert('Invalid date entry');
                return;
            }
            if(billingGroupID===-99){
                alert("Invalid Billing group ID, Please refresh page")
                return
            }
            else if (billingTableData){
                insertPricingRow(row, utility)
            }
            setNewRow({
                ...newRow,
                Price: undefined,
                PS: 1,
                UR: "U",
                knt: -1,
                Op: ">",
                EffectiveDate: new Date(viewDate).toISOString(),
                ExpirationDate: new Date(viewDate).toISOString()
            })
        }
        else {
            alert("Undefined input detected, fill out form before saving")
        }
    }

    const openNewPricingTable = () => {
        if (percentageIncrease) {
            let newPriceData: newBillingTableDataProps[] = []
            billingTableData?.forEach((x) => {
                let price = x.Price? x.Price.toFixed(2): "0.00"
                if(x.IsAutoRenew === true){
                    price = (x.Price ? (Math.round(x.Price * (1 + percentageIncrease / 100) * 100) / 100).toFixed(2) : "0.00")
                }
                newPriceData.push({
                    ...x, EffectiveDate: new Date(newEffectiveDate).toISOString(),
                    ExpirationDate: expire,
                    newPrice: price,
                    ContractExpirationDate: expire
                })
            })
            setViewBillingGroupTable(false)
            setNewBillingGroupTable(true)
            setNewPriceDate(newPriceData)
            setGenerateModal(false)
        }
        else {
            alert("insufficient percentage")
        }
    }

    const updateNewPricing = async (date: string, id: number, utility: utilityProps) => {
        let data = billingTableData?.find((x) => x.BillingGroupPriceID === id)
        if (data && billingTableData) {
            updateRow(data, date, utility)
        }
    }

    const utilityIdsSearch = (utility: string) =>{
        let utilityid = billingUtilities?.find((x: utilityProps) => x.UtilityName === utility) ?? {UtilityID: -99} as utilityProps
        return utilityid
    } 

    const updateRow = async (data: billingTableDataProps, expireDate: string, utility: utilityProps) => {
        axios.post(process.env.REACT_APP_API_URL + `/api/billing/UpdateBillingGroupPricing`, qsStringify({
            BillingGroupPriceID: data.BillingGroupPriceID,
            BillingGroupID: billingGroupTableID,
            UtilityCount: data.knt,
            Operator: data.Op,
            UtilityID: utility.UtilityID,
            ResponseID: data.ResponseID,
            BillingID: data.BillingID,
            Price: data.Price,
            SubPriceSchedule: data.UR,
            PriceScheduleID: data.PS,
            EffectiveDate: new Date(data.EffectiveDate).toUTCString(),
            ExpirationDate: new Date(expireDate).toUTCString(),
            IsAutoRenew: data.IsAutoRenew,
            ModifyDate: new Date().toUTCString(),
            ModifiedBy: userId,
            ContractID: utility.ContractID
        }), AxiosConfig.configValue())
            .finally(() => {
                viewBillingGroup()
            })
            .catch(error => {
                console.log(error)
                alert("There was an error updating Billing Group Pricing");
                logger.Error({
                    EventMessage: `BillingGroupPricing -> UpdateBillingGroupPricing -> Error : ${JSON.stringify(error)}`,
                    EventCategory: "httprequest"
                });
                AxiosConfig.handleError(error);
            })
    }

    const sortData = (prop: string) => {
        let property = prop as keyof billingTableDataProps
        let copyData = billingTableData
        let sortOrder: EventDictionary<string> = {}
        if (acDc[prop] === 'arrow_drop_up') {
            copyData?.sort((a, b) => {
                let c = a[property] ?? 0
                let d = b[property] ?? 0
                return c > d ? -1 : 1
            })
            sortOrder[prop] = 'arrow_drop_down'
        }
        else {
            copyData?.sort((a, b) => {
                let c = a[property] ?? 0
                let d = b[property] ?? 0
                return c > d ? 1 : -1
            })
            sortOrder[prop] = 'arrow_drop_up'
        }
        setACDC(sortOrder)
    }
    const insertNewBillingResponse = () => {
        if (billingResponses.find((x) => x.BillingResponse === newResponse) === undefined) {
            setBillingResponseModal(false)
            axios.post(process.env.REACT_APP_API_URL + "/api/billing/InsertBillingResponse", qsStringify({
                BillingResponse: newResponse,
                EntryDate: new Date().toUTCString()
            }), AxiosConfig.configValue())
                .then((res) => (setNewResponse("")))
                .finally(() =>
                    axios.get(process.env.REACT_APP_API_URL + `/api/billing/responses/`, AxiosConfig.configValue("min"))
                        .then((res) => {
                            let data = res.data
                            data = data.sort((a: billingResponsesProps, b: billingResponsesProps) => a.BillingResponse.toUpperCase() > b.BillingResponse.toUpperCase() ? 1 : -1)
                            setBillingResponses(data)
                        })
                )
        }
        else {
            alert("Billing Response already exists")
        }
    }

    const populateBillingGroupDropdown = () => {
        if (selectedBillingGroupOption && billingGroups?.find((element) => element.BillingGroupName == selectedBillingGroupOption.value) == undefined) {            
            setSelectedBillingGroupOption(null);
        }
        const options: { value: string, label: string }[] = [];

        billingGroups?.forEach((group) => {
            const option = { value: `${group.BillingGroupName}`, label: `${group.BillingGroupName} (${group.BillingGroupID})`}
            options.push(option);
        })

        return options;
    }

    const changeSelectedBillingGroup = (item: { value: string, label: string }) => {
        if (item != selectedBillingGroupOption) {
            setBillingDropdownTop(item.value);
            setSelectedBillingGroupOption(item);
        }

        // shows the spinner next to the Billing Group field
        if (viewDate && autoSearchLoading != 'group') {
            setAutoSearchLoading('group');
        }
    }

    // waits 1 second after date has changed before making the API call. Should allow the user to finish typing the date before the call is made to improve performance.
    const debounceDate = (event: ChangeEvent<HTMLInputElement>) => {
        const input = event.target.value
        
        // This should only be possible if the user clears out the date field either with the button or by manually deleting the values 
        if (input.length == 0) {
            setViewDate(null);            
            return
        }

        if(typingTimeout){
            clearTimeout(typingTimeout)
        }

        typingTimeout = setTimeout(() => {
            dateChanged(event)
        }, 1000)
    }
    const dateChanged = (event: ChangeEvent<HTMLInputElement>) => {
        if (dayjs(event.target.value).valueOf() == viewDate) {
            return;
        }
        setViewDate(dayjs(event.target.value).valueOf()); 

        // shows the spinner next to the date field
        if (selectedBillingGroupOption && autoSearchLoading != 'date') {
            setAutoSearchLoading('date');
        }       
    }

    useEffect(() => {
        // for the cases where either the user has clicked the 'clear' button OR they have manually deleted the date in the input field
        if (viewDate == null) {
            setViewBillingGroupTable(false);
            setBillingGroupTableID(undefined);
            setBillingGroupTableTitle(undefined);
            setBillingTableData(undefined);
            return;
        } 
        if (selectedBillingGroupOption && viewDate) {
            viewBillingGroup();
        }             
    }, [selectedBillingGroupOption, viewDate])

    useEffect(() => {
        let date = new Date(expire)
        date.setUTCFullYear(2099)
        date.setUTCMonth(11)
        date.setUTCDate(32)
        date.setUTCHours(0, 0, 0, 0)
        setExpire(date.toISOString())
        billingGroupType(includeInactiveBillingGroups)
        //r-18-lint-cn
        //eslint-disable-next-line
    }, [])

    useEffect(() => {
        setBillingTableData(billingTableData)
    }, [billingTableData])

    useEffect(() => {
        let allLocates: locatorProps[] = []
        //r-18-lint-cn
        //eslint-disable-next-line
        Object.keys(billingLocators).map((x) => allLocates.push(...billingLocators[x]))
        billingTableData?.map((x) => allLocates.push({ LocatorResponse: x.LocatorResponse, ResponseID: x.ResponseID }))
        let locateSet = new Set()
        let resLocates = allLocates.filter(entry => {
            if (locateSet.has(entry.LocatorResponse)) {
                return false;
            }
            locateSet.add(entry.LocatorResponse);
            return true;
        });
        let copyLocate = billingLocators
        //r-18-lint-cn
        //eslint-disable-next-line
        emptyLocate.map(x => {
            copyLocate[x] = resLocates
        })
        setBillingLocators({ ...copyLocate })
        //r-18-lint-cn
        //eslint-disable-next-line
    }, [emptyLocate])

    return (
        <div className="main-content col-sm">
            <div className="groupFilters">
                <div className="billingGroupDate">
                    <b style={{ marginRight: '2rem' }}>Date:</b>                   
                    <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '0.5rem'}}>
                        <Form.Control
                            type="date"
                            onChange={(e: ChangeEvent<HTMLInputElement>) => debounceDate(e) }
                            defaultValue={dayjs(viewDate).format('YYYY-MM-DD')}
                            name='billingGroupDate'
                            max={dayjs().format('YYYY-MM-DD')}
                            disabled={newBillingGroupTable}         
                        />
                        {autoSearchLoading == 'date' && (
                            <div>
                                <Spinner id="billing-group-pricing-dummy-loader" animation="border"/>
                            </div>
                        )}
                    </div>
                </div>
                <div className="billingGroupType">
                    <b style={{ marginRight: '2rem' }}>Billing Group:</b>                    
                    <div style={{ display: 'flex', justifyContent: 'space-evenly', alignItems: 'center', gap: '0.5rem' }}>
                        <div style={{ width: '400px' }}>
                            <Select                               
                                options={populateBillingGroupDropdown()}
                                placeholder={'Select Billing Group'}
                                value={selectedBillingGroupOption}
                                onChange={(item: { value: string, label: string }) => changeSelectedBillingGroup(item)}
                                isDisabled={newBillingGroupTable}
                            />
                        </div>
                        {autoSearchLoading == 'group' && (
                            <div>
                                <Spinner id="billing-group-pricing-dummy-loader" animation="border"/>
                            </div>
                        )}
                    </div>
                </div>
                <div className="billingGroupInactive">
                    <Checkbox
                        isChecked={includeInactiveBillingGroups}
                        onChange={() => {
                            let bool = !includeInactiveBillingGroups
                            setIncludeInactiveBillingGroups(bool)
                            billingGroupType(bool)
                        }}
                        label="Include Inactive Billing Groups"
                        isDisabled={newBillingGroupTable}

                    />
                </div>
            </div>
            {
                viewBillingGroupTable ?
                    <div className="viewBillingGroupTable">
                        <div className="BGTableTop">
                            <span>{billingGroupTableTitle} ({billingGroupTableID})</span>
                            <Button onClick={() => setGenerateModal(true)} variant='secondary'>Generate Duplicate Pricing Records</Button>
                        </div>
                        <div className="BillingGroupTable">
                            <Table>
                                <thead>
                                    <tr className="tableHead">
                                        <th onClick={() => sortData("UtilityName")}>Utility<span className="material-icons">{acDc["UtilityName"]}</span></th>
                                        <th onClick={() => sortData("BillingResponse")}>Billing Response <span className="material-icons">{acDc["BillingResponse"]}</span></th>
                                        <th onClick={() => sortData("BillingID")}>Billing ID <span className="material-icons">{acDc["BillingID"]}</span> </th>
                                        <th onClick={() => sortData("LocatorResponse")}>Locator Response <span className="material-icons">{acDc["LocatorResponse"]}</span> </th>
                                        <th onClick={() => sortData("ResponseID")}>Response ID <span className="material-icons">{acDc["ResponseID"]}</span></th>
                                        <th onClick={() => sortData("IsAutoRenew")}>Auto Renew <span className="material-icons">{acDc["IsAutoRenew"]}</span></th>
                                        <th onClick={() => sortData("Price")}>Price <span className="material-icons">{acDc["Price"]}</span></th>
                                        <th onClick={() => sortData("PS")}>P/S <span className="material-icons">{acDc["PS"]}</span></th>
                                        <th onClick={() => sortData("UR")}>U/R  <span className="material-icons">{acDc["UR"]}</span></th>
                                        <th onClick={() => sortData("knt")}>Knt <span className="material-icons">{acDc["knt"]}</span></th>
                                        <th onClick={() => sortData("Op")}>Op <span className="material-icons">{acDc["Op"]}</span></th>
                                        <th onClick={() => sortData("EffectiveDate")}>Effective Date <span className="material-icons">{acDc["EffectiveDate"]}</span></th>
                                        <th onClick={() => sortData("ExpirationDate")}>Expiration Date <span className="material-icons">{acDc["ExpirationDate"]}</span></th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody className="BGPTableBody">

                                    {billingTableData ?
                                        billingTableData.map((x, index) => {
                                            return (
                                                <BillingTableEditableCell
                                                    key={index}
                                                    rowData={x}
                                                    index={index}
                                                    edit={false}
                                                    utilities={billingUtilities}
                                                    locators={billingLocators}
                                                    billing={billingResponses}
                                                    update={viewBillingGroup}
                                                    userId={userId}
                                                    billingGroupID={billingGroupTableID}
                                                    idSearch={utilityIdsSearch}
                                                />
                                            )
                                        }) : null
                                    }

                                    {
                                        insertRow ?
                                            <tr className="editableTable">
                                                <td className="editableResize">
                                                    <select
                                                        onChange={(e) => setNewRowData(e.target.value, "UtilityName")}
                                                        value={newRow.UtilityName}
                                                    >
                                                        {billingUtilities?.map((x: utilityProps, index: number) => (
                                                            <option key={index} value={x.UtilityName}>{x.UtilityName}</option>
                                                        ))}
                                                    </select></td>
                                                <td className="editableResize">
                                                    <select
                                                        onChange={(e) => setNewRowData(e.target.value, "BillingResponse")}
                                                        value={newRow.BillingResponse}
                                                    >
                                                        {billingResponses?.map((x: billingResponsesProps, index: number) => (
                                                            <option key={index} value={x.BillingResponse}>{x.BillingResponse}</option>
                                                        ))}
                                                    </select>
                                                </td>
                                                <td>{newRow.BillingID}</td>
                                                <td className="editableResize">
                                                    <select
                                                        onChange={(e) => setNewRowData(e.target.value, "LocaterResponse")}
                                                        value={newRow.LocatorResponse}
                                                    >
                                                        {billingLocators[newRow?.UtilityName]?.map((x: locatorProps, index: number) => (
                                                            <option key={index} value={x.LocatorResponse}>{x.LocatorResponse}</option>
                                                        ))}
                                                    </select>
                                                </td>
                                                <td>{newRow.ResponseID}</td>
                                                <td>
                                                    <div style={{position: "relative", top:4}}>
                                                        <FluentCheckbox checked = {newRow.IsAutoRenew} onChange={() => setNewRowData("", "IsAutoRenew")}/>
                                                    </div>
                                                </td>
                                                <td className="editablesMid" style={{ display: "flex", justifyContent: "left", alignItems: "center" }}>
                                                    $<input
                                                        id="billingPrice"
                                                        type="number"
                                                        onChange={(e) => setNewRowData(e.target.value, "Price")}
                                                        step="0.01"
                                                        onKeyDown={(event: KeyboardEvent<HTMLDivElement>) => ['e', 'E', '+', '-'].includes(event.key) && event.preventDefault()}
                                                    />
                                                </td>
                                                <td className="editablesSmall">
                                                    <input
                                                        type="number"
                                                        onChange={(e) => setNewRowData(e.target.value, "PS")}
                                                        onKeyDown={(event: KeyboardEvent<HTMLDivElement>) => ['e', 'E', '+', '-'].includes(event.key) && event.preventDefault()}
                                                        defaultValue={newRow.PS}
                                                    />
                                                </td>
                                                <td className="editablesSmall">
                                                    <input
                                                        type="text"
                                                        maxLength={1}
                                                        onChange={(e) => setNewRowData(e.target.value, "UR")}
                                                        value={newRow.UR}
                                                    />
                                                </td>
                                                <td className="editablesSmall">
                                                    <input
                                                        type="number"
                                                        onChange={(e) => setNewRowData(e.target.value, "knt")}
                                                        onKeyDown={(event: KeyboardEvent<HTMLDivElement>) => ['e', 'E', '+'].includes(event.key) && event.preventDefault()}
                                                        defaultValue={newRow.knt}
                                                    />
                                                </td>
                                                <td className="editablesSmall">
                                                    <input
                                                        type="text"
                                                        maxLength={1}
                                                        onChange={(e) => setNewRowData(e.target.value, "Op")}
                                                        value={newRow.Op}
                                                    />
                                                </td>
                                                <td className="tableDates">
                                                    <input
                                                        type='date'
                                                        onChange={(e) => { setNewRowData(moment(e.target.value).format('MM/DD/YYYY'), "EffectiveDate") }}
                                                        defaultValue={moment(newRow.EffectiveDate).format("YYYY-MM-DD")}
                                                    />
                                                </td>
                                                <td className="tableDates">
                                                    <input
                                                        type='date'
                                                        onChange={(e) => { setNewRowData(moment(e.target.value).format('MM/DD/YYYY'), "ExpirationDate") }}
                                                        defaultValue={moment(newRow.ExpirationDate).format("YYYY-MM-DD")}
                                                    />
                                                </td>
                                                <td>
                                                    <span className="material-icons"
                                                        onClick={() => {
                                                            setCancelAddRow(true)
                                                        }}
                                                    >
                                                        clear
                                                    </span>
                                                    <span className="material-icons" onClick={() => setAddRowCon(true)}>save</span>
                                                </td>
                                            </tr> :
                                            <tr className="editableTable">
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td><span className="material-icons" onClick={() => setInsertRow(true)}>add</span></td>
                                            </tr>
                                    }
                                </tbody>
                            </Table>
                        </div>
                        <div className="responseModalButtons">
                            <Button variant="secondary" onClick={() => setBillingResponseModal(true)}>
                                <span> Billing Response</span>
                                <span className="material-icons">add</span>
                            </Button>
                            <Button variant="secondary" onClick={() => setLocatorResponseModal(true)}>
                                <span> Locator Response</span>
                                <span className="material-icons">add</span>
                            </Button>
                            <Button 
                                variant="secondary" 
                                onClick={() => setAvailableLocatorResponseModal(true)}                             
                            >
                                <span> Available Locator Response</span>
                            </Button>
                        </div>
                    </div>
                    : null
            }
            {
                <Modal show={availableLocatorResponseModal} onHide={() => setAvailableLocatorResponseModal(false)} size="xl">
                    <Modal.Body>
                        <div className="AddEditTabs">
                            <div className={tab === "Add"? "ClickedInvoiceCompareTab":"InvoiceCompareTab"} onClick={() => setTab("Add")}>
                                <span>Add</span>
                            </div>
                            <div className={tab === "Edit"? "ClickedInvoiceCompareTab":"InvoiceCompareTab"} onClick={() => setTab("Edit")}>
                                <span>Edit</span>
                            </div>
                        </div>
                        <div style={{margin: '10px', textAlign: "center", borderBottom: '1px solid lightgrey'}}>
                            <h4>{tab} Available Locator Response</h4>
                        </div>
                        {
                            tab === 'Add'?
                            <AddAvailableResponse
                                Utilities={billingUtilities ?? [{ UtilityID: -99, UtilityName: "", ContractExpirationDate: "", ContractID: -99 }]}
                                billinggroupid={billingGroups?.find(x => x.BillingGroupName === billingDropdownTop)?.BillingGroupID ?? -99}
                                //r-18-lint-cn
                                //eslint-disable-next-line
                                close={() => (setAvailableLocatorResponseModal(false), setNewResponse(""))}
                                refresh={viewBillingGroup}
                            />: 
                            <EditAvailableResponse
                                Utilities={billingUtilities ?? [{ UtilityID: -99, UtilityName: "", ContractExpirationDate: "", ContractID: -99 }]}
                                billinggroupid={billingGroups?.find(x => x.BillingGroupName === billingDropdownTop)?.BillingGroupID ?? -99}
                                //r-18-lint-cn
                                //eslint-disable-next-line
                                close={() => (setAvailableLocatorResponseModal(false), setNewResponse(""))}
                                refresh={viewBillingGroup}
                            />
                        }
                    </Modal.Body>
                </Modal>
            }
            {
                <Modal show={locatorResponseModal} onHide={() => setLocatorResponseModal(false)} size='sm'>
                    <Modal.Header>
                        Add Locator Response
                    </Modal.Header>
                    <Modal.Body>
                        <AddLocatorResponse
                            close={() => (setLocatorResponseModal(false))}
                            refresh={viewBillingGroup}
                        />
                    </Modal.Body>
                </Modal>
            }
            {
                <Modal show={billingResponseModal} onHide={() => setBillingResponseModal(false)} size='sm'>
                    <Modal.Header>
                        Add Billing Response
                    </Modal.Header>
                    <Modal.Body>
                        <div>
                            <div><span>Response: </span></div><Form.Control value={newResponse} type="text" onChange={(e) => setNewResponse(e.target.value)} />
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={() => (insertNewBillingResponse())}>Save</Button>
                        {/*r-18-lint-cn*/}
                        {/*eslint-disable-next-line*/}
                        <Button variant="secondary" onClick={() => (setBillingResponseModal(false), setNewResponse(""))}>Cancel</Button>
                    </Modal.Footer>
                </Modal>
            }
            {
                <Modal show={generateModal} size="lg" onHide={() => setGenerateModal(false)}>
                    <Modal.Header>
                        Duplicate Pricing Records
                    </Modal.Header>
                    <Modal.Body>
                        <div className="newEffectiveDate">
                            <span style={{ marginRight: '4.7rem', marginLeft: "5px" }}>Effective Date</span>
                            <div className="bgDateInput">
                                <input type='date' onChange={(e) => { setNewEffectiveDate(moment(e.target.value).valueOf()) }} defaultValue={moment(newEffectiveDate).format("YYYY-MM-DD")} />
                            </div>
                            <span className="material-icons">calendar</span>
                        </div>
                        <div className="percentageIncrease">
                            <span style={{ marginRight: '2rem' }}>
                                Percentage Increase
                            </span>
                            <input
                                type="number"
                                onChange={(e) => setPercentageIncrease(Number(e.target.value))}
                                onKeyDown={(event: KeyboardEvent<HTMLDivElement>) => ['e', 'E', '+', '-'].includes(event.key) && event.preventDefault()}
                            />
                            <span className="material-icons">
                                percent
                            </span>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={() => setGenerateModal(false)} variant='secondary'>Cancel</Button>
                        <Button onClick={() => isNaN(newEffectiveDate) ? alert("invalid Effective Date") : openNewPricingTable()} variant='primary'>Calculate</Button>
                    </Modal.Footer>
                </Modal>
            }
            {
                newBillingGroupTable ?
                    <BillingGroupNewPricing 
                        rowData={newPriceData} 
                        cancelClick={cancelClick} 
                        EffectiveDate={newEffectiveDate} 
                        confirmationCall={updateNewPricing} 
                        insertCall={insertPricingRow} 
                        idSearch={utilityIdsSearch}
                        billingGroupID={billingGroupTableID ?? -99}
                        percent={percentageIncrease ?? 0}
                    />
                    : null
            }
            <Modal show={addRowCon} size="lg" onHide={() => setAddRowCon(false)}>
                <Modal.Header>
                    <span>Are you sure you want to add a new record </span>
                </Modal.Header>
                <Modal.Footer>
                    {/*r-18-lint-cn*/}
                    {/*eslint-disable-next-line*/}
                    <Button onClick={() => (insertNewPricingRow(newRow), setAddRowCon(false))} variant='primary'>Yes</Button>
                    <Button onClick={() => setAddRowCon(false)} variant='secondary'>No</Button>
                </Modal.Footer>
            </Modal>
            <Modal show={cancelAddRow} size="lg" onHide={() => setCancelAddRow(false)}>
                <Modal.Header>
                    <span>Are you sure you want to cancel adding a new Record</span>
                </Modal.Header>
                <Modal.Footer>
                    <Button
                        onClick={() => {
                            if (viewDate == null) {
                                alert('Invalid date entry');
                                return;
                            }
                            setInsertRow(false)
                            setNewRow({
                                ...newRow,
                                Price: undefined,
                                PS: 1,
                                UR: "U",
                                knt: -1,
                                Op: ">",
                                EffectiveDate: new Date(viewDate).toISOString(),
                                ExpirationDate: new Date(viewDate).toISOString()
                            })
                            setCancelAddRow(false)
                        }}
                        variant='primary'
                    >
                        Yes
                    </Button>
                    <Button onClick={() => setCancelAddRow(false)} variant='secondary'>No</Button>
                </Modal.Footer>
            </Modal>
            <Prompt
                when={insertRow}
                message='You have unsaved changes, are you sure you want to leave?'
            />
        </div>
    )
}

const mapStateToProps = (state: any) => ({
    username: state.user.userName,
    userid: state.user.userId
})

export default connect(mapStateToProps)(BillingGroupPricing)